import React from 'react';
import { useInView } from 'react-intersection-observer';
const ProductImageAnimated = (props) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
    });
    return (React.createElement("div", { ref: ref, className: 'product-image--animate' + (inView && props.imageLoaded ? ' animated from-' + props.direction : '') }, props.children));
};
export default ProductImageAnimated;
